import { format } from 'date-fns'
import { ja } from 'date-fns/locale'
import { SubscriptionSchedule, SubscriptionInventory } from '~/api-client/data-contracts'

type Props = {
  schedules: SubscriptionSchedule[]
  selectedInventories: SubscriptionInventory[]
  delayedWeek?: number
  className?: string
}

const formatDate = (date: Date) => {
  return format(date, 'M/d（E）', { locale: ja })
}

export const EstimatedDelivery: React.FC<Props> = ({ schedules, selectedInventories, delayedWeek = 0, className = '' }) => {
  const selectedInventory = selectedInventories[0]
  const selectedSchedule = schedules.find((s) => s.relationships.inventory.data.id === selectedInventory?.id)

  if (!selectedSchedule) return null

  const dates = selectedSchedule.attributes.deliver_at.map((ts: number) => new Date(ts * 1000))

  if (dates.length === 0) return null

  const deliverAt = dates.map((date) => formatDate(date)).join('〜')
  const weekday = format(dates[0], 'E', { locale: ja })
  const week = selectedInventory?.attributes.week

  return (
    <div className={`bg-bg rounded-2xl p-4 space-y-3 ${className}`}>
      <p className="text-[15px] font-bold text-black">初回のお届け</p>
      <div className="space-y-1">
        <p className="text-[19px] font-bold text-black">{deliverAt}</p>
        <div className="flex items-start gap-1.5 text-dark-gray text-[13px]">
          <svg className="w-4 h-4 mt-0.5 shrink-0" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="1.5" y="3" width="13" height="12" rx="2" stroke="#828282" strokeWidth="1.2" />
            <path d="M5 1.5V4M11 1.5V4" stroke="#828282" strokeWidth="1.2" strokeLinecap="round" />
            <path d="M1.5 7H14.5" stroke="#828282" strokeWidth="1.2" />
          </svg>
          {delayedWeek === 0 ? (
            <p className="text-[13px]">{`月に${selectedInventories.length}回・${weekday}曜日にお届け`}</p>
          ) : (
            <div className="space-y-1">
              <p className="text-accent">年末年始のため配送スケジュールが変更になります</p>
              <ul className="list-disc ml-4 leading-relaxed">
                <li>{`初回のみ第${(week + delayedWeek) % 4}${weekday}曜日にお届け`}</li>
                <li>{`2回目以降は第${week}${weekday}曜日にお届け`}</li>
              </ul>
            </div>
          )}
        </div>
        <div className="flex items-start gap-1.5 text-dark-gray">
          <svg className="w-4 h-4 mt-0.5 shrink-0" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 5.5L8 2L15 5.5V11.5L8 15L1 11.5V5.5Z" stroke="#828282" strokeWidth="1.2" strokeLinejoin="round" />
            <path d="M8 2V15M1 5.5L8 9L15 5.5" stroke="#828282" strokeWidth="1.2" strokeLinejoin="round" />
          </svg>
          <p className="text-[13px]">クロネコヤマトで配送（対面でのお受け取り）</p>
        </div>
      </div>
    </div>
  )
}
